import React from 'react';
import {
  View, StyleSheet, ViewStyle, Text,
} from 'react-native';
import Colors from '../../../../constants/Colors';
import SunnyIcon from '../icons/SunnyIcon';
import CloudyIcon from '../icons/CloudyIcon';
import ClearCloudyIcon from '../icons/ClearCloudyIcon';
import PartlyCloudyIcon from '../icons/PartlyCloudy';
import MostlyCloudyIcon from '../icons/MostlyCloudy';
import ShowersIcon from '../icons/ShowersIcon';
import DrizzleIcon from '../icons/DrizzleIcon';
import WindyIcon from '../icons/WindyIcon';
import HailIcon from '../icons/HailIcon';
import SleetIcon from '../icons/SleetIcon';
import SnowIcon from '../icons/SnowIcon';
import SnowFlurriesIcon from '../icons/SnowFlurriesIcon';
import IsolatedThunderstormsIcon from '../icons/IsolatedThunderstormsIcon';
import ThunderstormsIcon from '../icons/ThunderstormsIcon';
import TornadoIcon from '../icons/TornadoIcon';
import {
  daysOfWeek, monthFullNames, WeatherCondition, WeatherDataItem,
} from '../data';

const WeatherConditionInfo = {
  [WeatherCondition.SUNNY]: { title: 'Sunny', icon: <SunnyIcon /> },
  [WeatherCondition.CLOUDY]: { title: 'Cloudy', icon: <CloudyIcon /> },
  [WeatherCondition.CLEAR_CLOUDY]: { title: 'Clear/Cloudy', icon: <ClearCloudyIcon /> },
  [WeatherCondition.PARTLY_CLOUDY]: { title: 'Partly cloudy', icon: <PartlyCloudyIcon /> },
  [WeatherCondition.MOSTLY_CLOUDY]: { title: 'Mostly cloudy', icon: <MostlyCloudyIcon /> },
  [WeatherCondition.SHOWERS]: { title: 'Showers', icon: <ShowersIcon /> },
  [WeatherCondition.DRIZZLE]: { title: 'Drizzle', icon: <DrizzleIcon /> },
  [WeatherCondition.WINDY]: { title: 'Windy', icon: <WindyIcon /> },
  [WeatherCondition.HAIL]: { title: 'Hail', icon: <HailIcon /> },
  [WeatherCondition.SLEET]: { title: 'Sleet', icon: <SleetIcon /> },
  [WeatherCondition.SNOW]: { title: 'Snow', icon: <SnowIcon /> },
  [WeatherCondition.SNOW_FLURRIES]: { title: 'Snow flurries', icon: <SnowFlurriesIcon /> },
  [WeatherCondition.ISOLATED_THUNDERSTORMS]: {
    title: 'Isolated thunderstorms', icon: <IsolatedThunderstormsIcon />,
  },
  [WeatherCondition.THUNDERSTORMS]: { title: 'Thunderstorms', icon: <ThunderstormsIcon /> },
  [WeatherCondition.TORNADO]: { title: 'Tornado', icon: <TornadoIcon /> },
};

interface WeatherDashboardItemProps extends WeatherDataItem {
  style?: ViewStyle | ViewStyle[],
}

const WeatherDashboardItem = ({
  date, temperature, condition, style,
}: WeatherDashboardItemProps) => <View style={[styles.item, style]}>
    {(date && new Date(date)) ? <View>
      <Text style={styles.date}>{daysOfWeek[new Date(date).getDay() - 1]}</Text>
      <Text style={styles.date}>
        {`${new Date(date).getDate()} ${monthFullNames[new Date(date).getMonth()]}`}
      </Text>
    </View> : <Text style={styles.date}>{'-'}</Text>}
    <View>
      <View style={styles.row}>
        {WeatherConditionInfo[condition]?.icon}
        <Text style={styles.temperature}>{`${temperature ?? '-'}°`}</Text>
      </View>
      <Text style={styles.condition}>{WeatherConditionInfo[condition]?.title ?? '-'}</Text>
    </View>
  </View>;

const styles = StyleSheet.create({
  item: {
    width: 148,
    height: 152,
    padding: 8,
    marginHorizontal: 4,
    borderRadius: 10,
    backgroundColor: Colors.light.hereworksSkyBlue,
    justifyContent: 'space-between',
  },
  date: {
    fontSize: 12,
    lineHeight: 10,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack400,
    marginBottom: 8,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  temperature: {
    fontSize: 24,
    lineHeight: 24,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksDarkBlue,
    marginStart: 8,
  },
  condition: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack500,
    marginTop: 4,
  },
});

export default WeatherDashboardItem;
